/**
 * Matches `src/styles/_brand-tokens.scss` for inline styles (MUI sx, etc.).
 * Change both when updating the product brand.
 */
export const BRAND_PRIMARY = 'rgb(255, 104, 40)';
export const BRAND_PRIMARY_HOVER = 'rgb(230, 90, 32)';
export const BRAND_PRIMARY_08 = 'rgba(255, 104, 40, 0.08)';
export const BRAND_CONTENT_BG = 'rgb(253, 242, 236)';
export const BRAND_TEXT_ON_INVERSE = 'rgb(255, 255, 255)';
